import Box from "@material-ui/core/Box"
import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Radio from "@material-ui/core/Radio"
import Typography from "@material-ui/core/Typography"
import React from "react"
import { HourReportWorkflow } from "../../api"
import { useHourReportWorkflowTranslations } from "./use-translations"

type ApprovalWorkflowProps = {
  selected: boolean
  disabled: boolean
  reviewRequiresSubmission: boolean
  onReviewRequiresSubmissionChange: (checked: boolean) => void
}

const ApprovalWorkflow = ({
  selected,
  disabled,
  reviewRequiresSubmission,
  onReviewRequiresSubmissionChange,
}: ApprovalWorkflowProps) => {
  const translations = useHourReportWorkflowTranslations()

  return (
    <React.Fragment>
      <FormControlLabel
        value={HourReportWorkflow.Approval}
        disabled={disabled}
        control={<Radio color="primary" style={{ marginRight: 12, marginTop: -12 }} />}
        label={
          <Box py={0.5}>
            <Typography variant="subtitle1">{translations.approvalLabel}</Typography>
            <Typography variant="body2" color="textSecondary">
              {translations.approvalDescription}
            </Typography>
          </Box>
        }
      />
      {selected && (
        <Box ml={4} mb={2} mt={1}>
          <FormControlLabel
            style={{ display: "flex" }}
            disabled={disabled}
            control={
              <Checkbox
                checked={reviewRequiresSubmission}
                style={{ marginRight: 8, marginTop: -12 }}
                color="primary"
                onChange={(event) => onReviewRequiresSubmissionChange(event.target.checked)}
              />
            }
            label={
              <Box py={0.5}>
                <Typography variant="subtitle1">{translations.requireSubmissionBeforeApprovalLabel}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {translations.requireSubmissionBeforeApprovalDescription}
                </Typography>
              </Box>
            }
          />
        </Box>
      )}
    </React.Fragment>
  )
}

export default ApprovalWorkflow
